import { Flex } from "antd";

import { PageBlock } from "@/shared/pageComposition";

import { ProfileActionsBlock } from "./blocks/ProfileActionsBlock";
import { ProfileSummaryBlock } from "./blocks/ProfileSummaryBlock";
import { ProgressSyncBlock } from "./blocks/ProgressSyncBlock";
import { UserInfoBlock } from "./blocks/UserInfoBlock/UserInfoBlock";
import { UserSettingsBlock } from "./blocks/UserSettingsBlock/UserSettingsBlock";
import { MainInformationModel } from "./MainInformation.model";

export const getMainInformationBlocks = (
    model: MainInformationModel,
): PageBlock<MainInformationModel>[] => [
    {
        key: "profile-summary",
        order: 10,
        render: () => (
            <ProfileSummaryBlock
                onOpenChangePhoto={model.actions.onOpenChangePhoto}
            />
        ),
    },
    {
        key: "profile-information",
        order: 20,
        render: () => (
            <Flex vertical gap={32} style={{ marginBottom: 8 }}>
                <UserInfoBlock capabilities={model.capabilities} />
                <UserSettingsBlock />
                <ProgressSyncBlock />
            </Flex>
        ),
    },
    {
        key: "profile-actions",
        order: 30,
        render: () => (
            <ProfileActionsBlock
                onOpenCameraMode={model.actions.onOpenCameraMode}
            />
        ),
    },
];
